import { driver } from "driver.js";
import { useEffect } from "react";

import "./index.css";

export const useTour = () => {
  const driverObj = driver({
    allowClose: false,
    animate: false,
    nextBtnText: "&#8594;",
    popoverClass: "driverjs-theme",
    prevBtnText: "&#8592;",
    showProgress: true,
    steps: [
      {
        element: "#tour-1",
        popover: {
          description: "根据您的投资目标，预估您将能获得的收益",
          title: "预测收益",
        },
      },
      {
        element: "#tour-2",
        popover: {
          description: "修改您的投资目标，可以实时看到收益变化",
          title: "筛选项",
        },
      },
      {
        element: "#tour-3",
        popover: {
          description: "精确展示您的投资数据",
          title: "数据图表",
        },
      },
    ],
  });
  useEffect(() => {
    // 检查 localStorage 中是否已经访问过页面
    const hasVisitedBefore = localStorage.getItem("hasVisited");

    if (!hasVisitedBefore) {
      // 第一次访问，执行回调函数
      driverObj.drive();
      // 标记已经访问过页面
      localStorage.setItem("hasVisited", "true");
    }
  }, [driverObj]);

  const run = () => driverObj.drive();
  return { run };
};
